function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1.8-.006L17.58 15.78l-1.8 1.8L-.01 1.794zm13.98 13.983l1.8 1.8L1.8 31.564l-1.81-1.8z",
  fill: "#fff",
  fillRule: "evenodd"
});

function SvgArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.6,
    height: 31.563
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNy42IiBoZWlnaHQ9IjMxLjU2MyIgdmlld0JveD0iMCAwIDE3LjYgMzEuNTYzIj4KICA8ZGVmcz4KICAgIDxzdHlsZT4KICAgICAgLmNscy0xIHsKICAgICAgICBmaWxsOiAjZmZmOwogICAgICAgIGZpbGwtcnVsZTogZXZlbm9kZDsKICAgICAgfQogICAgPC9zdHlsZT4KICA8L2RlZnM+CiAgPHBhdGggaWQ9IkFycm93IiBjbGFzcz0iY2xzLTEiIGQ9Ik0yMTQxLjU4LDYyOC44NjlsMTUuNzgsMTUuNzg2LTEuOCwxLjgtMTUuNzktMTUuNzg2Wm0xMy45OCwxMy45ODMsMS44LDEuOC0xNS43OCwxNS43ODctMS44MS0xLjhaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMjEzOS43OCAtNjI4Ljg3NSkiLz4KPC9zdmc+Cg==";
export { SvgArrowRight as ReactComponent };